import script from "./MallTossReturnPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallTossReturnPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallTossReturnPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__